const GA_TRACKING_ID =
  window.REACT_APP_GA_TRACKING_ID ||
  import.meta.env.REACT_APP_GA_TRACKING_ID ||
  import.meta.env.VITE_GA_TRACKING_ID;

// Analytics'i bir kez yükle ve yapılandır
export const initializeAnalytics = () => {
  if (!GA_TRACKING_ID) {
    console.warn('Google Analytics Tracking ID bulunamadı.');
    return;
  }

  // window.dataLayer ve window.gtag fonksiyonunu script'ten önce tanımla
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(){window.dataLayer.push(arguments);};

  // Script'i yükle
  if (!document.querySelector(`script[src="https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}"]`)) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
    document.head.appendChild(script);
  }

  // GA4 config'i hemen çağır
  window.gtag('js', new Date());
  window.gtag('config', GA_TRACKING_ID, {
    send_page_view: true,
    anonymize_ip: true,
    cookie_flags: 'SameSite=Strict;Secure'
  });
};

// Sayfa değişikliklerini takip et (SPA için)
export const trackPageView = (url) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
    });
  }
};

// Event tracking (isteğe bağlı - sadece özel eventler için)
export const trackEvent = ({ action, category, label, value }) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};